import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

export const useEnableV3Coachmarks = () => useFeatureFlag(FeatureFlagDeclarations.enableV3Coachmarks);
